import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-number-box";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-date-time-picker";
import "./../../bindings/bao-toolbar2";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import BaoDialog from "./../../factories/bao-dialog";
class ServiceCategoryChangeDialog {
    Bao = Bao;
    Parent: any;
    TabPage: TabPage;
    Dialog = new BaoDialog(Bao.Session.ApplicationName);
    ChangeExistingServices = ko.observable("0");
    UpdateAmountAndPrice = ko.observable("0");
    UpdateServiceComponents = ko.observable(false);
    UpdateAmountAndPriceFiltered = ko.observable(false);
    DialogResult: KnockoutObservable<boolean> = this.Dialog.DialogResult;
    SlaCollection: KnockoutObservableArray<any> = ko.observableArray<any>([]);
    Sorting: KnockoutObservableArray<{
        Column: string;
        Direction: number;
    }> = ko.observableArray([]);
    SelectSlaRow = (data) => {
        data.Selected(!data.Selected());
    };
    Years: KnockoutObservableArray<number> = ko.observableArray([]);
    Months: KnockoutObservableArray<number> = ko.observableArray([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]);
    Year: KnockoutObservable<number | string> = ko.observable(null);
    Month: KnockoutObservable<number | string> = ko.observable(null);
    SlaTypes: KnockoutObservableArray<string> = ko.observableArray([]);
    SlaType: KnockoutObservable<number | string> = ko.observable(null);
    Rhythms: KnockoutObservableArray<string> = ko.observableArray([]);
    RhythmAdd: KnockoutObservable<number | string> = ko.observable(null);
    RhythmEdit: KnockoutObservable<number | string> = ko.observable(null);
    AmountAdd = ko.observable<number>();
    ServiceCategoryPrice = ko.observable<number>();
    NumberBoxAmountAdd: Bindings.baoNumberBox = {
        value: this.AmountAdd,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    AmountUpdate = ko.observable<number>();
    NumberBoxAmountUpdate: Bindings.baoNumberBox = {
        value: this.AmountUpdate,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    AmountFilter = ko.observable<number>();
    TarifFilter = ko.observable<number>();
    NumberBoxAmountFilter: Bindings.baoNumberBox = {
        value: this.AmountFilter,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    NumberBoxTarifFilter: Bindings.baoNumberBox = {
        value: this.TarifFilter,
        decimalDigits: 0,
        thousandSeperator: false,
        culture: Bao.Session.Language.Symbol()
    };
    constructor(tabPage: TabPage, parent: any) {
        this.TabPage = tabPage;
        this.Parent = parent;
        this.Sorting.subscribe(() => {
            //this.Search();
        });
        this.UpdateServiceComponents.subscribe((newValue) => {
            if (newValue == false) {
                this.UpdateAmountAndPriceFiltered(false);
            }
        });
        this.UpdateAmountAndPrice.subscribe((newValue) => {
            if (newValue == "0") {
                this.UpdateServiceComponents(false);
            }
        });
        this.SlaType.subscribe((newValue) => {
            //Aktualisiere die Liste der SLAs entsprechend der SLAType Auswahl
            this.TabPage.IsLoading(true);
            Bao.post("ServiceProviderTab/GetServiceLevelAgreements", JSON.stringify({
                sorting: this.Sorting(),
                slaType: this.SlaType()
            })).done((result: {
                Models: any;
                TotalRows: number;
            }) => {
                this.SlaCollection([]);
                if (result != null && result.Models != null) {
                    result.Models.forEach(x => x["Selected"] = ko.observable<boolean>(false));
                    this.SlaCollection(result.Models);
                }
                this.TabPage.IsLoading(false);
            });
        });
        this.Dialog.Buttons([
            {
                Title: Bao.Session.GetMessage("msgApply"),
                Click: () => {
                    this.DialogResult(true);
                    this.Dialog.Close();
                },
                Enabled: ko.observable(true),
                IsDefault: ko.observable(true),
                Focus: () => { }
            },
            {
                Title: Bao.Session.GetMessage("msgCancel"),
                Click: () => {
                    this.DialogResult(false);
                    this.Dialog.Close();
                },
                Enabled: ko.observable(true),
                IsDefault: ko.observable(false),
                Focus: () => { }
            }
        ]);
    }
    Show(sessionTabId, serviceProviderId, serviceCategoryId, serviceCategoryPrice) {
        this.TabPage.IsLoading(true);
        this.ServiceCategoryPrice(serviceCategoryPrice);
        Bao.post("ServiceProviderTab/ShowServiceCategoryChangeDialog", JSON.stringify({
            sessionTabId: sessionTabId,
            serviceProviderId: serviceProviderId,
            serviceCategoryId: serviceCategoryId,
            sorting: this.Sorting()
        }), (value) => {
            if (value != null && value.Models != null) {
                value.Models.forEach(x => x["Selected"] = ko.observable<boolean>(false));
                this.SlaCollection(value.Models);
            }
            this.Dialog.ViewModel(this);
            this.Dialog.Template(value.Message);
            this.Dialog.Open();
            this.TabPage.IsLoading(false);
        });
    }
    ;
    Search = () => {
        this.TabPage.IsLoading(true);
        Bao.post("ServiceProviderTab/GetAllServiceLevelAgreements", JSON.stringify({
            sorting: this.Sorting()
        })).done((result: {
            Models: any;
            TotalRows: number;
        }) => {
            this.SlaCollection([]);
            if (result != null && result.Models != null) {
                result.Models.forEach(x => x["Selected"] = ko.observable<boolean>(false));
                this.SlaCollection(result.Models);
            }
            this.TabPage.IsLoading(false);
        });
    };
    init(): JQueryPromise<any> {
        var def = $.Deferred();
        //Stichtag: Jahre
        Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), (result) => {
            var DatumAkt = new Date();
            var JahrAkt = DatumAkt.getFullYear();
            for (var r in result) {
                if (result[r].Key != "" && result[r].Key != null)
                    this.Years.push(result[r].Key);
            }
            this.Year(JahrAkt);
            //Verrechnungsart / Rhythm
            Bao.post("ServiceProviderTab/GetRhythmCollection", (result) => {
                this.Rhythms(result.Models);
                Bao.post("ServiceProviderTab/GetAllServiceLevelAgreementTypes", (result) => {
                    this.SlaTypes(result.Models);
                    def.resolve();
                });
            });
        });
        return def.promise();
    }
}
export default ServiceCategoryChangeDialog;